<template>
  <div class="">
    <div class="announcement w-1/2 -mx-5">
      <vs-card class="cardx bg-green-500">
        <!-- header -->
        <div slot="header" class="flex justify-between">
          <div class="flex">
            <feather-icon icon="BellIcon" svgClasses="mr-2" />
            <p class="text-lg font-bold">***Announcement***</p>
          </div>
          <feather-icon v-if="checkRolesByIds([ADMIN]) && !isMsgEditEnable" icon="EditIcon" svgClasses="cursor-pointer" @click="editAnnounceMentMessage" />
        </div>

        <!-- announcement message -->
        <div v-if="!isMsgEditEnable" v-html="announcement" class="p-3 text-white rounded notification__content text-lg text-justify"></div>

        <!-- ck editor -->
        <div v-if="checkRolesByIds([ADMIN]) && isMsgEditEnable">
          <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-5 items-center text-right">
                <vs-button color="danger" type="relief" class="text-left" @click="isMsgEditEnable = false">Cancel</vs-button>
                <vs-button class="ml-2 vs-con-loading__container" id="add-user-button" type="relief" @click="updateAnnouncementConfirmation">Save</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { mapGetters } from 'vuex'

import { ADMIN } from '@/utils/roles'

export default {
  name: 'Announcement',

  data() {
    return {
      ADMIN,
      isMsgEditEnable: false,
      announcement: null,
      editor: ClassicEditor,
      editorData: null,
      editorConfig: {
        placeholder: 'Enter Announcement Message Here'
      }
    }
  },

  mounted() {
    this.getAnnouncementMessage()
  },

  computed: {
    ...mapGetters('auth', ['checkRolesByIds'])
  },

  methods: {
    getAnnouncementMessage() {
      this.$store
        .dispatch('dashboard/getAnnouncement')
        .then(res => {
          const announcement = res.data.announcement
          this.announcement = announcement.value
          this.editorData = announcement.value
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    editAnnounceMentMessage() {
      this.isMsgEditEnable = true
    },

    updateAnnouncementConfirmation() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure, you want to update this message?',
        accept: () => this.updateAnnouncement(),
        acceptText: 'Yes'
      })
    },

    updateAnnouncement() {
      this.$store
        .dispatch('dashboard/updateAnnouncement', { announcement: this.editorData })
        .then(({ message }) => {
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.getAnnouncementMessage()
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
        .finally(() => {
          this.isMsgEditEnable = false
          this.editorData = null
        })
    }
  }
}
</script>

<style lang="scss">
.announcement {
  a {
    color: #fff !important;
    font-weight: 600;
    text-decoration: underline;
  }

  ul,
  ol {
    list-style-position: inside;
    padding-left: 1.25rem;

    li {
      margin-bottom: 5px;
      line-height: 1.5;
    }
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }
}
</style>
